import {
  PriceType,
  ProductPriceData,
  ProductPrices,
  ProductPriceTypes,
} from '../models';

export function pricesReducer(prices: ProductPriceData): ProductPriceTypes {
  return Object.keys(prices).reduce(
    (acc: ProductPriceTypes, key: PriceType) => {
      const pricesDic: ProductPrices = {};

      prices[key].forEach((priceData) => {
        pricesDic[priceData.productId] = priceData.prices;
      });

      acc[key] = pricesDic;

      return acc;
    },
    {} as ProductPriceTypes,
  );
}
